import React from 'react';
import ReactDOM from 'react-dom';
import { MessageSquarePlus } from 'lucide-react';

// Sits directly ABOVE the FloatingAIButton (same portal + container-relative
// coords). Offset = AI button height (~34px) + a 10px gap, subtracted so it
// floats above.
const ABOVE_OFFSET = 44;

const FloatingCommentButton = ({ position, show, onClick, portalContainer }) => {
  if (!show || !position || !position.visible) return null;
  if (!portalContainer) return null;

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onClick();
  };

  const handleMouseDown = (e) => {
    // Keep the editor's text selection alive so the new comment can anchor to it.
    e.preventDefault();
    e.stopPropagation();
  };

  const button = (
    <button
      onClick={handleClick}
      onMouseDown={handleMouseDown}
      data-testid="floating-comment-button"
      className="absolute bg-white dark:bg-slate-800 text-amber-600 dark:text-amber-400 border border-amber-300 dark:border-amber-700 rounded-md px-2.5 py-1.5 shadow-lg hover:shadow-xl hover:bg-amber-50 dark:hover:bg-slate-700 transition-all cursor-pointer"
      style={{
        top: `${position.top - ABOVE_OFFSET}px`,
        left: `${position.left}px`,
        pointerEvents: 'auto',
        zIndex: 30,
      }}
      title="Comentar selección"
    >
      <MessageSquarePlus className="w-5 h-5" />
    </button>
  );

  return ReactDOM.createPortal(button, portalContainer);
};

export default FloatingCommentButton;
